import { Header, LeftComponentsHeader } from '@components/navigation/Header/Header';
import { Nav } from '@components/navigation/Nav/Nav';
import { PageTitle } from '@components/navigation/Nav/PageTitle';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

export const SettingsHeader = memo(function SettingsHeader() {
    return (
        <Header>
            <LeftComponentsHeader>
                <Nav>
                    <PageTitle>
                        <FormattedMessage id="nav.title.settings" />
                    </PageTitle>
                </Nav>
            </LeftComponentsHeader>
        </Header>
    );
});
